(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  class YGTextWithIcons extends HTMLElement {
    constructor() {
      super();
      this.handleAutoplayStateChange = this.handleAutoplayStateChange.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.carousel = this.querySelector('text-with-icons-carousel[autoplay]');
      this.mobileMediaQuery = window.matchMedia('(max-width: 699px)');

      if (!this.carousel) {
        return;
      }

      this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange(this.mobileMediaQuery);
    }

    disconnectedCallback() {
      if (this.mobileMediaQuery) {
        this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
      }

      this.unbindPlayer();
    }

    handleBreakpointChange(event) {
      if (!event.matches) {
        this.resetProgressState();
        this.unbindPlayer();
        return;
      }

      this.bindPlayer();
    }

    bindPlayer() {
      if (!this.isConnected || !this.mobileMediaQuery?.matches) {
        return;
      }

      this.player = this.carousel?.player;

      if (!this.player) {
        requestAnimationFrame(() => this.bindPlayer());
        return;
      }

      if (this.playerBound) {
        return;
      }

      ['player:start', 'player:stop', 'player:visibility-pause', 'player:visibility-resume'].forEach((eventName) => {
        this.player.addEventListener(eventName, this.handleAutoplayStateChange);
      });

      this.playerBound = true;
    }

    unbindPlayer() {
      if (!this.playerBound || !this.player) {
        return;
      }

      ['player:start', 'player:stop', 'player:visibility-pause', 'player:visibility-resume'].forEach((eventName) => {
        this.player.removeEventListener(eventName, this.handleAutoplayStateChange);
      });

      this.playerBound = false;
      this.player = null;
    }

    resetProgressState() {
      this.style.setProperty('--text-with-icons-progress-duration', '0s');
      this.style.setProperty('--text-with-icons-progress-play-state', 'paused');
    }

    handleAutoplayStateChange(event) {
      switch (event.type) {
        case 'player:start':
          this.style.setProperty('--text-with-icons-progress-duration', `${this.carousel.getAttribute('autoplay')}s`);
          this.style.setProperty('--text-with-icons-progress-play-state', 'running');
          break;
        case 'player:stop':
          this.resetProgressState();
          break;
        case 'player:visibility-pause':
          this.style.setProperty('--text-with-icons-progress-play-state', 'paused');
          break;
        case 'player:visibility-resume':
          this.style.setProperty('--text-with-icons-progress-play-state', 'running');
          break;
      }
    }
  }

  if (!window.customElements.get('yg-text-with-icons')) {
    window.customElements.define('yg-text-with-icons', YGTextWithIcons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoList01 extends HTMLElement {
      constructor() {
        super();
        this.playbackMode = this.getAttribute('data-playback-mode');
        this.slideItems = this.querySelectorAll('.yg-video-list-01__slide');
        this.handleClickPlayback = this.handleClickPlayback.bind(this);
        this.handleVideoProgress = this.handleVideoProgress.bind(this);
      }

      connectedCallback() {
        this.addEventListener('YG:videoProgress', this.handleVideoProgress);

        if (this.playbackMode === 'click') {
          this.addEventListener('click', this.handleClickPlayback, true);
        }

        if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
          this.initHoverPlayback();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClickPlayback, true);
        this.removeEventListener('YG:videoProgress', this.handleVideoProgress);
      }

      handleClickPlayback(event) {
        const target = event.target instanceof Element ? event.target : null;
        const playButton = target ? target.closest('.yg-play') : null;
        if (!playButton || !this.contains(playButton)) return;

        const currentVideo = playButton.closest('yg-video');
        if (!currentVideo || !this.contains(currentVideo)) return;

        this.pauseOtherVideos(currentVideo);
      }

      pauseOtherVideos(currentVideo) {
        this.querySelectorAll('yg-video').forEach((videoEl) => {
          if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
          videoEl.pauseVideo();
        });
      }

      handleVideoProgress(event) {
        const videoHost = event.target instanceof Element ? event.target.closest('yg-video') : null;
        const slide = videoHost ? videoHost.closest('.swiper-slide') : null;
        const progress = slide ? slide.querySelector('.yg-video-list-01__progress') : null;
        if (!progress) return;

        const value = Number(event.detail?.progress);
        const safeValue = Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
        progress.style.setProperty('--yg-video-progress', `${safeValue}%`);
      }

      initHoverPlayback() {
        this.slideItems.forEach((item) => {
          const videoEl = item.querySelector('yg-video');
          if (!videoEl) return;

          item.addEventListener('mouseenter', () => {
            if (videoEl.playVideo) {
              videoEl.playVideo();
            }
          });

          item.addEventListener('mouseleave', () => {
            if (videoEl.pauseVideo) {
              videoEl.pauseVideo();
            }
          });
        });
      }
    }

    if (!window.customElements.get('yg-video-list-01')) {
      window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
